import React from 'react'
import {KTSVG} from '../../../../../../../template/_metronic/helpers'

type Props = {
  title: string
  description?: string | JSX.Element
  icon: string
  className?: string
}

export const SymbolLabel = ({title, description, icon, className}: Props) => {
  return (
    <span className={`d-flex align-items-center ${className}`}>
      <span className='symbol symbol-circle symbol-50px me-6'>
        <span className='symbol-label bg-light-primary'>
          <KTSVG path={icon} className='svg-icon-2 text-primary' />
        </span>
      </span>
      <span className='d-flex flex-column'>
        <span className='fw-semibold text-primary-dark fs-2'>{title}</span>
        {description && <span className='fw-semibold fs-2 text-gray'>{description}</span>}
      </span>
    </span>
  )
}
